import { DownloadAppCard } from "./cards/download-app";
import { ExploreServicesCard } from "./cards/explore-services";
import { FacebookReviewCard } from "./cards/facebook-review";
import { GoogleReviewCard } from "./cards/google-review";
import { InstagramCard } from "./cards/instagram";
import { QuoraReviewCard } from "./cards/quora-review";
import { ScheduleCallCard } from "./cards/schedule-call";
import { SuggestFeatureCard } from "./cards/suggest-feature";
import { TryPreferencesCard } from "./cards/try-preferences";
import { PROMOTIONAL_CARD_IDS, PromotionalCardConfig } from "./types";

/**
 * Registry of all promotional cards.
 * To add a new card:
 * 1. Create the card component in ./cards/
 * 2. Add entry to PROMOTIONAL_CARD_IDS in promotional-card-types.ts
 * 3. Add configuration here with visibility conditions
 */
export const PROMOTIONAL_CARDS_REGISTRY: PromotionalCardConfig[] = [
	{
		id: PROMOTIONAL_CARD_IDS.DOWNLOAD_APP,
		component: DownloadAppCard,
		priority: 9, // Very high priority
		visibilityConditions: () => true, // Always visible, adapts content based on device
		pages: ["search", "sup", "project"],
	},
	{
		id: PROMOTIONAL_CARD_IDS.SCHEDULE_CALL,
		component: ScheduleCallCard,
		priority: 7,
		visibilityConditions: () => true, // Always visible
		pages: ["search", "sup", "project"],
	},
	{
		id: PROMOTIONAL_CARD_IDS.SUGGEST_FEATURE,
		component: SuggestFeatureCard,
		priority: 5,
		visibilityConditions: () => true, // Always visible
		pages: ["search", "sup", "project"],
	},
	{
		id: PROMOTIONAL_CARD_IDS.TRY_PREFERENCES,
		component: TryPreferencesCard,
		priority: 8, // Higher priority to encourage preference creation
		visibilityConditions: ctx => ctx.isBuyer && !ctx.hasPreferences, // Only show for buyers without preferences
		pages: ["search", "sup", "project"],
	},
	{
		id: PROMOTIONAL_CARD_IDS.QUORA_REVIEW,
		component: QuoraReviewCard,
		priority: 4,
		visibilityConditions: ctx => ctx.isAuthenticated, // Logged-in only
		pages: ["search", "sup", "project"],
	},
	{
		id: PROMOTIONAL_CARD_IDS.EXPLORE_SERVICES,
		component: ExploreServicesCard,
		priority: 6,
		visibilityConditions: () => true, // Always visible
		pages: ["search", "sup", "project"],
	},
	{
		id: PROMOTIONAL_CARD_IDS.FACEBOOK_REVIEW,
		component: FacebookReviewCard,
		priority: 4,
		visibilityConditions: ctx => ctx.isAuthenticated, // Logged-in only
		pages: ["search", "sup", "project"],
	},
	{
		id: PROMOTIONAL_CARD_IDS.GOOGLE_REVIEW,
		component: GoogleReviewCard,
		priority: 5,
		visibilityConditions: ctx => ctx.isAuthenticated, // Logged-in only
		pages: ["search", "sup", "project"],
	},
	{
		id: PROMOTIONAL_CARD_IDS.INSTAGRAM,
		component: InstagramCard,
		priority: 5,
		visibilityConditions: () => true, // Always visible
		pages: ["search", "sup", "project"],
	},
];
